import React, { useEffect, useRef } from "react";
import ArrowRightIcon from "../../assets/svg/arrow-right-white.svg";
import ChooseWeatIcon from "../../assets/images/choose-weat.png";
import PreferredNutrientsIcon from "../../assets/images/preferred-nutrients.png";
import FreshForYouIcon from "../../assets/images/fresh-for-you.png";
import PackagedDeliveredIcon from "../../assets/images/packaged-delivered.png";
import GetInTouch from "./GetInTouch";
import OurProductCarousel from "./OurProductCarousel";
import Banner from "../Banner/Banner";
import OurHappyClient from "./OutHappyClient";
import MoolchandjiFoods from "../../assets/Videos/MoolchandjiFoods.mp4";
import "../../assets/scss/component/_home.scss";


const Home = () => {
    const videoRef = useRef(null);
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (videoRef.current) {
                    if (entry.isIntersecting) {
                        videoRef.current.play().catch((err) => {
                            console.log("Autoplay blocked", err);
                        });
                    } else {
                        videoRef.current.pause();
                    }
                }
            },
            {
                threshold: 0.5,
            }
        );

        if (videoRef.current) {
            observer.observe(videoRef.current);
        }

        return () => observer.disconnect();
    }, []);
    return (
        <>
            <Banner />
            <div className="our-product pb_100 home">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="section-title">
                                <h5>Top Selling Products <a href="/shop" className="btn_link">View All</a></h5>
                                <p>Select Customise, and convert with precision.</p>
                            </div>
                        </div>

                        <div className="col-12">
                            <div className="product-slider">
                                <OurProductCarousel />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className={'customize-your-wheat'}>
                <div className="customize-box">
                    <h2 className={'fs_40 text-white fw_700 mb_20'}>
                        Customize Your Wheat into Wholesome Flour
                    </h2>
                    <p className={'fs_20 fw_400 text-white mb_30'}>Select your preferred wheat variety, personalize it with nutritious add-ons, and transform it into wholesome, custom-made flour tailored to your needs.</p>
                    <a href="/customize-wheat" className={'d-inline-block fs_20 fw_500 text-white text-uppercase d-flex align-items-center text-decoration-underline'}>Get Started<img className={'img-fluid ml_12'} src={ArrowRightIcon} alt="Arrow Right White" /></a>
                </div>
            </div>

            <div className="how-it-work py_100 mobile_hide">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="section-title pb_30">
                                <h5>How It Works</h5>
                                <p>Creating your own custom flour is simple and rewarding</p>
                            </div>
                        </div>

                        <div className="col-md-12 my-4">
                            <div className={'d-flex pb_100 work-1 how-work position-relative'}>
                                <div className="how-it-work text-end pb_100 d-flex justify-content-lg-end">
                                    <div className={'how-it-work-content'}>
                                        <h5 className={'fs_24 fw_700 mb_38 text-color pt_20'}>Choose Your Wheat</h5>
                                        <p className={'fs_20 fw_400 text-color mb-0 lh-1-5 text-capitalize'}>Start by selecting from a variety of high-quality wheat types—such as Sharbati, Lokwan, or MP Wheat—based on your taste, texture preference, and nutritional needs. Each variety offers a unique flavor and health benefit.</p>
                                    </div>
                                    <div className={'work-number ml_40'}>
                                        <span className={'fs_40 fw_700 text-white'}>1</span>
                                    </div>
                                </div>
                                <div className="how-it-work-img ml_36">
                                    <img className={'img-fluid'} src={ChooseWeatIcon} alt="Choose Your Wheat ICon" />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 my-4">
                            <div className={'d-flex justify-content-end pb_100 work-2 how-work position-relative'}>
                                <div className="how-it-work-img mr_36">
                                    <img className={'img-fluid'} src={PreferredNutrientsIcon} alt="Preferred Nutrients Icon" />
                                </div>
                                <div className="how-it-work pb_100 d-flex">
                                    <div className={'work-number mr_40'}>
                                        <span className={'fs_40 fw_700 text-white'}>2</span>
                                    </div>
                                    <div className={'how-it-work-content'}>
                                        <h5 className={'fs_24 fw_700 mb_38 text-color pt_20'}>Add Your Preferred Nutrients</h5>
                                        <p className={'fs_20 fw_400 text-color mb-0 lh-1-5 text-capitalize'}>Enhance your flour by adding healthy ingredients like flax seeds for Omega-3s, ragi for calcium, oats for fiber, or other superfoods. You can choose single or multiple add-ons to suit your dietary goals.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-12 my-4">
                            <div className={'d-flex pb_100 work-3 how-work position-relative'}>
                                <div className="how-it-work text-end pb_100 d-flex justify-content-end">
                                    <div className={'how-it-work-content'}>
                                        <h5 className={'fs_24 fw_700 mb_38 text-color pt_20'}>We Mill It Fresh for You</h5>
                                        <p className={'fs_20 fw_400 text-color mb-0 lh-1-5 text-capitalize'}>Once your selection is finalized, we freshly grind your wheat and add-ons using hygienic, slow-cold milling methods to preserve nutrients, aroma, and natural taste—without any preservatives or chemicals.</p>
                                    </div>
                                    <div className={'work-number ml_40'}>
                                        <span className={'fs_40 fw_700 text-white'}>3</span>
                                    </div>
                                </div>
                                <div className="how-it-work-img ml_36">
                                    <img className={'img-fluid'} src={FreshForYouIcon} alt="Fresh For You Icon" />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 my-4">
                            <div className={'d-flex how-work justify-content-end'}>
                                <div className="how-it-work-img mr_36">
                                    <img className={'img-fluid'} src={PackagedDeliveredIcon} alt="Packaged Delivered Icon" />
                                </div>
                                <div className="how-it-work d-flex">
                                    <div className={'work-number mr_40'}>
                                        <span className={'fs_40 fw_700 text-white'}>4</span>
                                    </div>
                                    <div className={'how-it-work-content'}>
                                        <h5 className={'fs_24 fw_700 mb_38 text-color pt_20'}>Packaged & Delivered</h5>
                                        <p className={'fs_20 fw_400 text-color mb-0 lh-1-5 text-capitalize'}>Your wholesome, customized flour is then securely packed in eco-friendly packaging and delivered straight to your doorstep—fresh, flavorful, and ready to use.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="how_it_work mobile_show py_50">
                <div className="container">
                    <div className="row">
                        <div className="col-12 my-4 steup_left">
                            <div className="d-flex align-items-center justify-content-start w-100">
                                <div className="circle">1</div>
                                <p>Choose Your Wheat</p>
                            </div>
                        </div>
                        <div className="col-12 my-4 steup_right">
                            <div className="d-flex align-items-center justify-content-end ms-auto w-100">
                                <div className="circle">2</div>
                                <p>Add Your Preferred Nutrients</p>
                            </div>
                        </div>
                        <div className="col-12 my-4 steup_left">
                            <div className="d-flex align-items-center justify-content-start w-100">
                                <div className="circle">3</div>
                                <p>We Mill It Fresh for You</p>
                            </div>
                        </div>
                        <div className="col-12 my-4 ">
                            <div className="d-flex align-items-center justify-content-end ms-auto w-100">
                                <div className="circle">4</div>
                                <p>Packaged & Delivered</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className={'our-happy-client py_50'}>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="section-title ms-0 text-start mb_50">
                                <h5>Our Happy Clients</h5>
                                <p>What Our Customers Say About Their Wholesome Flour Experience</p>
                            </div>
                        </div>

                        <div className="col-12">
                            <div className="our-client-slider">
                                <OurHappyClient />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="how-we-work py_100">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="section-title mx-850 mb_50">
                                <h5>Introducing Moolchandji Foods: Fresh Customized Atta Now in Panipat!</h5>
                            </div>
                        </div>

                        <div className="col-md-10">
                            <div className="how-it-work-video position-relative">
                                <video
                                    ref={videoRef}
                                    className="img-fluid w-100"
                                    controls
                                    loop
                                    playsInline
                                    webkit-playsinline="true"
                                >
                                    <source src={MoolchandjiFoods} type="video/mp4" />
                                </video>
                            </div>

                            <p className={'mt_30 fs_20 fw_400 text-color lh-1-5'}>Moolchandji Foods brings a revolutionary health concept to Panipat! We offer premium quality, freshly milled customized atta tailored to your health needs. Choose from high-quality wheat, select your customized grain and pulse add-ons (like Chana, Oats, Ragi, or Bajra), and get it freshly milled exactly how you like it. Order online through our website or try our quick WhatsApp chatbot ordering for an easy and seamless checkout. Freshness, purity, and custom nutrition, delivered straight to your doorstep in Panipat!</p>
                        </div>
                    </div>
                </div>
            </div>

            <GetInTouch />
        </>
    );
};

export default Home;
